import React, { useState } from "react";
import style from "./Nav.module.css";

import Hamburger from "../Hamburger/Hamburger";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Ajnavidyalogo from "../../../Assets/Ajnavidyalogo.svg";
import DefaultIcon from "../../../Assets/DefaultIcon.svg";
import { useEffect } from "react";
import { notification } from "socket";
import { studentActions } from "redux/actions";
import { useDispatch } from "react-redux";

export const WithoutLoginNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [user, setUser] = useState("");
  const userid = window.location.search.split("?")[1];

  useEffect(() => {
    dispatch(studentActions.setStudent(userid)).then((_) => {
      setUser("student");
    });
  }, []);

  const navigateTo = (path) => {
    navigate(path);
  };

  return (
    <div className={style.mainCont}>
      <div className={style.container}>
        <div className={style.ajnvidyaCont1}>
          <div
            className={style.logo}
            onClick={() => navigate("/hiring/student/findjob")}
          >
            <img src={Ajnavidyalogo} alt="" />
          </div>
          {/* <div
            className={style.ajnavidyaTxt}
            onClick={() => navigate('/hiring/student/findjob')}
          >
            Ajna<span>Vidya</span>
          </div> */}
        </div>

        <div className="without-login">
          <button className="btn-primary login" onClick={() => navigateTo("/")}>
            Login
          </button>
          <button
            className="btn-primary signup"
            onClick={() => navigateTo("/hiring/signup")}
          >
            Signup
          </button>
        </div>
      </div>
    </div>
  );
};
